var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.className,on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("left-icon"),_c('span',[_vm._v(_vm._s(_vm.name.length ? _vm.name : 'i\'m button'))]),_vm._t("right-icon")],2)}
var staticRenderFns = []

export { render, staticRenderFns }